import { useQuery } from '@tanstack/vue-query'

import { fetchHealth } from '@/shared/api/health'
import { queryKeys } from '@/shared/api/queryKeys'

/**
 * Live API liveness state for the shell.
 *
 * All server state goes through TanStack Query (SPEC.md §3.2, §10.2) — including this one read,
 * so the very first data-fetching code in the repository sets the pattern the rest follows.
 *
 * @example
 * const { data, isPending, isError } = useApiHealth()
 */
export function useApiHealth() {
  return useQuery({
    queryKey: queryKeys.health(),
    queryFn: ({ signal }) => fetchHealth(signal),
    // A health probe is cheap and its whole value is being current; 30 s matches the
    // "documents" staleTime tier of §10.2 rather than the 5 min reference-data tier.
    staleTime: 30_000,
    retry: 1,
  })
}
